import { QueryHandler } from '@/redux/types/query-handler';
import { dispatchOptimisticPatchDeleteUser } from './dispatch-optimistic-patch';
import { DeleteUserQueryArg } from '../types/query-arg';

export const handleResultDeleteUser: QueryHandler<
  DeleteUserQueryArg,
  void
> = async (queryArg, { dispatch, getState, queryFulfilled }) => {
  const { patch } = dispatchOptimisticPatchDeleteUser(queryArg, {
    dispatch,
    getState,
  });

  try {
    await queryFulfilled;
  } catch (err) {
    patch.undo();
    throw err;
  }
};
